import * as React from 'react';

import FiltersButton from 'bundles/search-common/components/experiments/filters2024/FiltersButton';
import { userFiltersAdapter } from 'bundles/search-common/components/experiments/filters2024/filterValueAdapter';
import useStableSearchResults from 'bundles/search-common/utils/useStableSearchResults';

type Props = { onClick: () => void; showLabel?: boolean };

export const ContextAwareFilterButton = (props: Props): React.ReactElement => {
  const { onClick, showLabel } = props;
  const { facetFilters } = useStableSearchResults() || {};
  const numActiveFilters = React.useMemo(() => {
    return [...new Set((userFiltersAdapter(facetFilters) || []).flat())].length;
  }, [facetFilters]);
  return <FiltersButton numActiveFilters={numActiveFilters} showLabel={Boolean(showLabel)} onClick={onClick} />;
};

export default ContextAwareFilterButton;
